import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Valitud:

  <span style="color:#85c1dc;">**FI:**</span>
  Valittu:

  <span style="color:#85c1dc;">**RU:**</span>
  Выбрано:
*/
/* @__NO_SIDE_EFFECTS__ */
const m335 = msg(
  mf`Valitud:`,
  mf`Valittu:`,
  mf`Выбрано:`,
)

export { m335 as 'w.global.selected_option' }